import { render } from "./TraderPayoutLimitBanner.vue?vue&type=template&id=0b01bece&ts=true"
import script from "./TraderPayoutLimitBanner.vue?vue&type=script&lang=ts"
export * from "./TraderPayoutLimitBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__